<template>
  <el-pagination
    style="width: 700px; margin:  50px auto 0 auto;"
    :current-page.sync="pageIndex"
    :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
    :page-size="pageSize"
    layout="sizes, prev, pager, next, jumper"
    :total="total"
    @size-change="onPageSizeChange"
    @current-change="onPageChange"
  />
</template>

<script>
  import request from "../../api/request";
  import {assign} from "lodash"

  export default {
    name: "DataList",
    props: {
      api: { type: String, default: '' },
      model: { type: String, default: 'front'},
      filter: { type: Object, default: () => { return null } },
      sort: { type: Array, default: () => null },
      params: { type: Object, default: () => { return {} } },
      defaultPageSize: { type: Number, default: 10 },
      defaultPageIndex: { type: Number, default: 1 }
    },
    data() {
      return {
        pageSize: this.defaultPageSize,
        pageIndex: this.defaultPageIndex,
        total: 999999 * this.defaultPageSize
      };
    },
    computed: {
    },
    watch: {
      filter: function () {
        this.loadData()
      },
      sort: function () {
        this.loadData()
      }
    },
    created() {
      this.loadData();
    },
    methods: {
      async loadData() {
        let param = {}
        assign(param, this.params)
        param['range'] = [ this.pageSize * (this.pageIndex - 1), this.pageSize * this.pageIndex ]
        if (this.filter && Object.keys(this.filter).length > 0) {
          param['filter'] = this.filter
        }
        if (this.sort && Object.keys(this.sort).length > 0) {
          param['sort'] = this.sort
        }
        await request[this.model].post(this.api, param).then(resp => {
            let list = this.model === 'library' ? resp.data.products :resp.data.list
          if (list.length !== this.pageSize) {
            this.total = this.pageIndex * this.pageSize
          } else {
            this.total = this.pageSize * 999999
          }
          this.$emit("data-changed", list)
        });
      },

      onPageSizeChange(sz) {
        this.total = sz * 999999
        this.pageSize = sz
        this.loadData()
      },

      onPageChange() {
        this.loadData()
      }
    }
  };
</script>
